"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplementalCoveragesDetails = exports.eShippingContainers = exports.ePollutantCleanupAndRemoval = exports.eFreightCharges = exports.eEmergencyServiceCharges = exports.eExtraExpense = exports.eDebrisRemoval = exports.eContractualPenalties = exports.eContingentCoverage = exports.eBusinessPersonalProperty = exports.eRewardExpense = void 0;
const supplementalCoverages_class_1 = __importDefault(require("./supplementalCoverages.class"));
var eRewardExpense;
(function (eRewardExpense) {
    eRewardExpense["FIVE_THOUSAND"] = "5000";
    eRewardExpense["TEN_THOUSAND"] = "10000";
})(eRewardExpense = exports.eRewardExpense || (exports.eRewardExpense = {}));
var eBusinessPersonalProperty;
(function (eBusinessPersonalProperty) {
    eBusinessPersonalProperty["TEN_THOUSAND"] = "10000";
    eBusinessPersonalProperty["FIFTEEN_THOUSAND"] = "15000";
    eBusinessPersonalProperty["TWENTY_THOUSAND"] = "20000";
    eBusinessPersonalProperty["TWENTY_FIVE_THOUSAND"] = "25000";
})(eBusinessPersonalProperty = exports.eBusinessPersonalProperty || (exports.eBusinessPersonalProperty = {}));
var eContingentCoverage;
(function (eContingentCoverage) {
    eContingentCoverage["TWO_THOUSAND_FIVE_HUNDRED"] = "2500";
    eContingentCoverage["TWENTY_FIVE_THOUSAND"] = "25000";
    eContingentCoverage["FIFTY_THOUSAND"] = "50000";
    eContingentCoverage["SEVENTY_FIVE_THOUSAND"] = "75000";
    eContingentCoverage["ONE_HUNDRED_THOUSAND"] = "100000";
    eContingentCoverage["ONE_HUNDER_TWENTY_FIVE_THOUSAND"] = "125000";
    eContingentCoverage["ONE_HUNDRED_FIFTY_THOUSAND"] = "150000";
    eContingentCoverage["ONE_HUNDRED_SEVENTY_FIVE_THOUSAND"] = "175000";
    eContingentCoverage["TWO_HUNDRED_THOUSAND"] = "200000";
    eContingentCoverage["TWO_HUNDRED_TWENTY_FIVE_THOUSAND"] = "225000";
    eContingentCoverage["TWO_HUNDRED_FIFTY_THOUSAND"] = "250000";
    eContingentCoverage["TWO_HUNDRED_SEVENTY_FIVE_THOUSAND"] = "275000";
    eContingentCoverage["THREE_HUNDRED_THOUSAND"] = "300000";
})(eContingentCoverage = exports.eContingentCoverage || (exports.eContingentCoverage = {}));
var eContractualPenalties;
(function (eContractualPenalties) {
    eContractualPenalties["TEN_THOUSAND"] = "10000";
    eContractualPenalties["FIFTEEN_THOUSAND"] = "15000";
    eContractualPenalties["TWENTY_THOUSAND"] = "20000";
    eContractualPenalties["TWENTY_FIVE_THOUSAND"] = "25000";
})(eContractualPenalties = exports.eContractualPenalties || (exports.eContractualPenalties = {}));
var eDebrisRemoval;
(function (eDebrisRemoval) {
    eDebrisRemoval["TWENTY_FIVE_THOUSAND"] = "25000";
    eDebrisRemoval["THIRTY_THOUSAND"] = "30000";
    eDebrisRemoval["FORTY_THOUSAND"] = "40000";
    eDebrisRemoval["FIFTY_THOUSAND"] = "50000";
    eDebrisRemoval["SIXTY_THOUSAND"] = "60000";
    eDebrisRemoval["SEVENTY_FIVE_THOUSAND"] = "75000";
})(eDebrisRemoval = exports.eDebrisRemoval || (exports.eDebrisRemoval = {}));
var eExtraExpense;
(function (eExtraExpense) {
    eExtraExpense["TEN_THOUSAND"] = "10000";
    eExtraExpense["FIFTEEN_THOUSAND"] = "15000";
    eExtraExpense["TWENTY_THOUSAND"] = "20000";
    eExtraExpense["TWENTY_FIVE_THOUSAND"] = "25000";
})(eExtraExpense = exports.eExtraExpense || (exports.eExtraExpense = {}));
var eEmergencyServiceCharges;
(function (eEmergencyServiceCharges) {
    eEmergencyServiceCharges["TEN_THOUSAND"] = "10000";
    eEmergencyServiceCharges["FIFTEEN_THOUSAND"] = "15000";
    eEmergencyServiceCharges["TWENTY_THOUSAND"] = "20000";
    eEmergencyServiceCharges["TWENTY_FIVE_THOUSAND"] = "25000";
})(eEmergencyServiceCharges = exports.eEmergencyServiceCharges || (exports.eEmergencyServiceCharges = {}));
var eFreightCharges;
(function (eFreightCharges) {
    eFreightCharges["TWO_THOUSAND_FIVE_HUNDRED"] = "2500";
    eFreightCharges["FIVE_THOUSAND"] = "5000";
    eFreightCharges["TEN_THOUSAND"] = "10000";
})(eFreightCharges = exports.eFreightCharges || (exports.eFreightCharges = {}));
var ePollutantCleanupAndRemoval;
(function (ePollutantCleanupAndRemoval) {
    ePollutantCleanupAndRemoval["TEN_THOUSAND"] = "10000";
    ePollutantCleanupAndRemoval["FIFTEEN_THOUSAND"] = "15000";
    ePollutantCleanupAndRemoval["TWENTY_THOUSAND"] = "20000";
    ePollutantCleanupAndRemoval["TWENTY_FIVE_THOUSAND"] = "25000";
})(ePollutantCleanupAndRemoval = exports.ePollutantCleanupAndRemoval || (exports.ePollutantCleanupAndRemoval = {}));
var eShippingContainers;
(function (eShippingContainers) {
    eShippingContainers["FIVE_THOUSAND"] = "5000";
    eShippingContainers["TEN_THOUSAND"] = "10000";
    eShippingContainers["FIFTEEN_THOUSAND"] = "15000";
    eShippingContainers["TWENTY_THOUSAND"] = "20000";
    eShippingContainers["TWENTY_FIVE_THOUSAND"] = "25000";
})(eShippingContainers = exports.eShippingContainers || (exports.eShippingContainers = {}));
class SupplementalCoveragesDetails {
    constructor(data) {
        this.businessPersonalProperty = data.businessPersonalProperty;
        this.contingentCoverage = data.contingentCoverage;
        this.contractualPenalties = data.contractualPenalties;
        this.debrisRemoval = data.debrisRemoval;
        this.extraExpense = data.extraExpense;
        this.emergencyServiceCharges = data.emergencyServiceCharges;
        this.freightCharges = data.freightCharges;
        this.newlyAcquiredTerminals = data.newlyAcquiredTerminals;
        this.pollutantCleanupAndRemoval = data.pollutantCleanupAndRemoval;
        this.shippingContainers = data.shippingContainers;
    }
    static empty() {
        const data = {
            businessPersonalProperty: null,
            contingentCoverage: null,
            contractualPenalties: null,
            debrisRemoval: null,
            extraExpense: null,
            emergencyServiceCharges: null,
            freightCharges: null,
            newlyAcquiredTerminals: null,
            pollutantCleanupAndRemoval: null,
            shippingContainers: null
        };
        return new SupplementalCoveragesDetails(data);
    }
    static fromObj(data) {
        return new SupplementalCoveragesDetails({
            businessPersonalProperty: data.businessPersonalProperty,
            contingentCoverage: data.contingentCoverage,
            contractualPenalties: data.contractualPenalties,
            debrisRemoval: data.debrisRemoval,
            extraExpense: data.extraExpense,
            emergencyServiceCharges: data.emergencyServiceCharges,
            freightCharges: data.freightCharges,
            newlyAcquiredTerminals: data.newlyAcquiredTerminals,
            pollutantCleanupAndRemoval: data.pollutantCleanupAndRemoval,
            shippingContainers: data.shippingContainers
        });
    }
}
exports.SupplementalCoveragesDetails = SupplementalCoveragesDetails;
exports.default = supplementalCoverages_class_1.default;
//# sourceMappingURL=index.js.map